module.exports = __webpack_public_path__ + "img/server.919901ff.svg";